//
import Vue from "vue"
import Router from "vue-router"

//
Vue.use(Router)

//
import auth from "./auth"
import dashboard from "./dashboard"
import guard from "./guard"

//
const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [
        ...dashboard,
        ...auth,
    ],
})

// Global guard for router
router.beforeEach(guard)

//
export default router